import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Linkedin } from "lucide-react";
import { Reveal, Overline } from "./primitives";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const GalleryTeaser = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    fetch(`${API}/li-gallery`).then((r) => (r.ok ? r.json() : { items: [] }))
      .then((d) => setItems((d.items || []).filter((it) => it.image).slice(0, 6))).catch(() => {});
  }, []);
  if (!items.length) return null;
  return (
    <section className="py-20 border-t border-white/5" data-testid="gallery-teaser">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div>
              <Overline>From our LinkedIn</Overline>
              <h2 className="font-heading font-bold text-gf-text text-base md:text-lg mt-4 flex items-center gap-2">
                <Linkedin className="w-4 h-4 text-gf-primary" /> Visual insights, organised by topic — tariffs, ToD, BESS and more.
              </h2>
            </div>
            <Link to="/gallery" data-testid="gallery-teaser-cta"
              className="inline-flex items-center gap-1.5 font-body text-xs text-gf-primary border border-gf-primary/40 px-3 py-2 hover:bg-gf-primary/10">
              Browse the gallery <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </div>
          <div className="grid grid-cols-3 md:grid-cols-6 gap-2 mt-8">
            {items.map((it) => (
              <Link key={it.id} to="/gallery" className="group relative overflow-hidden border border-white/10" data-testid={`gallery-teaser-item-${it.activity_id}`}>
                <img src={it.image} alt={it.topic} loading="lazy"
                  className="w-full aspect-square object-cover group-hover:scale-[1.05] transition-transform duration-500" />
                <span className="absolute bottom-1 left-1 font-mono text-[7px] uppercase tracking-wider bg-gf-bg/85 text-gf-primary px-1.5 py-0.5">{it.topic}</span>
              </Link>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
